import CloseIcon from "@mui/icons-material/Close";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { useState } from "react";

const PaymentOptionModal = ({ open, onClose, payOnDelivery, payOnline }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleConfirm = () => {
    if (selectedOption === "online") {
      console.log("Pay Online clicked");
      payOnline();
    } else if (selectedOption === "cod") {
      console.log("Pay on Delivery clicked");
      payOnDelivery();
    }
    onClose();
    setSelectedOption(null);
  };

  const handleCancel = () => {
    setSelectedOption(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontSize: "1.25rem",
            color: "#333",
            fontFamily: "'Roboto', sans-serif",
          }}
        >
          Choose Payment Method
        </Typography>

        <IconButton onClick={handleCancel}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} direction="column">
          <Grid item>
            <Button
              variant={selectedOption === "online" ? "contained" : "outlined"}
              fullWidth
              startIcon={<CreditCardIcon />}
              onClick={() => setSelectedOption("online")}
              sx={{
                backgroundColor:
                  selectedOption === "online" ? "#5EC401" : undefined,
                color: selectedOption === "online" ? "#fff" : undefined,
                "&:hover": {
                  backgroundColor:
                    selectedOption === "online" ? "#5EC401" : "#fff",
                },
                textTransform: "none",
                py: 1.5,
                fontSize: "1rem",
              }}
            >
              Pay Securely Online
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant={selectedOption === "cod" ? "contained" : "outlined"}
              fullWidth
              startIcon={<LocalAtmIcon />}
              onClick={() => setSelectedOption("cod")}
              sx={{
                backgroundColor:
                  selectedOption === "cod" ? "#5EC401" : undefined,
                color: selectedOption === "cod" ? "#fff" : undefined,
                "&:hover": {
                  backgroundColor:
                    selectedOption === "cod" ? "#5EC401" : "#e3f2fd",
                },
                textTransform: "none",
                py: 1.5,
                fontSize: "1rem",
              }}
            >
              Pay at Delivery(COD)
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button
          onClick={handleConfirm}
          disabled={!selectedOption}
          sx={{
            backgroundColor: "#5EC401",
            color: "#fff",
            marginRight: "15px",
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentOptionModal;
